import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/cloud-new/cloud_banner.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service on_demand_banner cloud_computing_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner">Cloud Consulting Services</h1>
              <span>
                Win Over New-Age Challenges Using Novel Cloud Technologies
              </span>
              <p>
                With 6 years of cloud consulting expertise, TekRevol excels in
                developing strategic cloud adoption plans, optimizing costs,
                developing advanced cloud-native apps, and executing seamless
                legacy infrastructure migrations. Our deep AWS, Azure, and
                Google Cloud prowess ensures custom cloud solutions for
                operational efficiency and innovative business expansion.
                Partner with us to transform your cloud-based growth journey.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Consult Our Cloud Team
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center"
          >
            {/* <div className="cloud_banner_gif">
              <img src={GIF} alt="TekRevol" />
            </div> */}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
